import { Component } from '@angular/core';

@Component({
    selector: 'app-simple-fu',
    imports: [],
    templateUrl: './simple-fu.component.html',
    styleUrl: './simple-fu.component.scss'
})
export class SimpleFuComponent {

    // File Uploader
    public multiple: boolean = false;

}